import logoPngBlack from 'assets/images/logo_paynow_black.png';
import logoPng from 'assets/images/logo_paynow_white.png';
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { trimLanguageTag } from 'helpers/commonHelper';
import withLocaleContext from 'hoc/withLocaleContext';
import chevronLeftWhiteSvg from 'assets/images/chevron-left-white.svg';
import chevronLeftBlackSvg from 'assets/images/chevron-left-black.svg';
import {
  Container,
  ContainerHeader,
  GoBackButtonRow,
  GoBackButtonWrapper,
  LanguageOption,
  LanguageSelect,
} from './Header.styles';
import Locale from '../../types/Locale';
import { IHeaderProps } from './Header.types';

function HeaderComponent({ locale, returnToShopEnabled, setLocaleSelectedByUser, continueUrl }: IHeaderProps) {
  const currentLanguage = locale && trimLanguageTag(locale);

  const onsetLocale = useCallback(
    (event: React.MouseEvent<HTMLSpanElement>) => {
      const currentLocale = event.currentTarget.getAttribute('data-locale');
      if (setLocaleSelectedByUser && currentLocale) {
        setLocaleSelectedByUser(currentLocale);
      }
    },
    [setLocaleSelectedByUser]
  );

  const redirectToUrl = () => {
    if (continueUrl) {
      window.location.assign(continueUrl);
    }
  };

  return (
    <Container $hasAdditionalButtons={returnToShopEnabled}>
      <ContainerHeader data-testid="header:container">
        <img className="logo-mobile" alt="logo-mobile" src={logoPngBlack} />
        <img className="logo-desktop" alt="logo-desktop" src={logoPng} />
        {currentLanguage && (
          <LanguageSelect>
            {Object.keys(Locale).map(key => (
              <LanguageOption
                key={key}
                currentLanguage={currentLanguage}
                className={
                  currentLanguage === trimLanguageTag(Locale[key])
                    ? 'language-select__option active'
                    : 'language-select__option'
                }
                languageKey={Locale[key]}
                onClick={onsetLocale}
                data-locale={Locale[key]}
              >
                <FormattedMessage id={`locale.${Locale[key]}`} />
              </LanguageOption>
            ))}
          </LanguageSelect>
        )}
      </ContainerHeader>
      {returnToShopEnabled && (
        <GoBackButtonWrapper className="header_back-to-shop-button">
          <button type="button" onClick={redirectToUrl}>
            <GoBackButtonRow>
              <img className="chevron-left-mobile" alt="go back to shop icon" src={chevronLeftBlackSvg} />
              <img className="chevron-left-desktop" alt="go back to shop icon" src={chevronLeftWhiteSvg} />
              <FormattedMessage id="backToShop" />
            </GoBackButtonRow>
          </button>
        </GoBackButtonWrapper>
      )}
    </Container>
  );
}

export default withLocaleContext(HeaderComponent);
